import { z } from 'zod';
import { passwordSchema } from '../auth/schemas.js';
// ── Self-service account ─────────────────────────────────────────────────────
export const updateProfileSchema = z.object({ name: z.string().trim().min(2).max(120) });
export const changePasswordSchema = z
    .object({ currentPassword: z.string().min(1).max(256), newPassword: passwordSchema })
    .refine((v) => v.currentPassword !== v.newPassword, {
    path: ['newPassword'],
    message: 'Choose a password you have not used just now',
});
// ── Tenant user & role administration ───────────────────────────────────────
export const updateUserSchema = z
    .object({
    name: z.string().trim().min(2).max(120),
    status: z.enum(['active', 'disabled']),
    roleKeys: z.array(z.string().min(2)).min(1),
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, 'Nothing to update');
export const roleKeySchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z][a-z0-9_]{1,39}$/, 'Lowercase letters, numbers and underscores; start with a letter');
export const createRoleSchema = z.object({
    key: roleKeySchema,
    name: z.string().trim().min(2).max(80),
    description: z.string().trim().max(240).nullish(),
    permissions: z.array(z.string()).min(1, 'Choose at least one permission'),
});
export const updateRoleSchema = createRoleSchema
    .omit({ key: true })
    .partial()
    .refine((v) => Object.keys(v).length > 0, 'Nothing to update');
// ── Support access (tenant grants, Super Admin uses, read-only, audited) ─────
export const grantSupportAccessSchema = z.object({ hours: z.number().int().min(1).max(72) });
//# sourceMappingURL=account.js.map